import Home from "./pages/Home.svelte";
import Error from "./pages/Error.svelte";
import Login from "./pages/Login.svelte";
import Signup from "./pages/Signup.svelte";
import HomeAdmin from "./pages/HomeAdmin.svelte";

export default [
  {
    path: "/",
    component: Home,
    auth: true
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/signup/:uid",
    component: Signup
  },
  {
    path: "/admin",
    component: HomeAdmin,
    auth: true,
    role: "admin"
  },
  {
    path: "*",
    component: Error
  }
];